import { inject, Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from './cookie.service';
import { UmamiService } from './umami.service';

@Injectable({
    providedIn: 'root',
})
export class LanguageService {
    languageCode = signal<string>('de');
    private translate = inject(TranslateService);
    private router = inject(Router);
    private cookieService = inject(CookieService);

    constructor() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                if (
                    this.router.url.split('/')[1] === 'de' ||
                    this.router.url.split('/')[1] === 'en'
                ) {
                    this.setLanguageCode = this.router.url.split('/')[1];
                } else {
                    this.setLanguageCode = 'de';
                }
                this.translate.use(this.languageCode());
                this.cookieService.subscribe();
            }
        });
    }

    get getLanguageCode() {
        return this.languageCode();
    }

    set setLanguageCode(code: string) {
        this.languageCode.set(code);
    }

    isLanguageSelected(languageCode: string) {
        return this.languageCode() === languageCode;
    }

    changeLanguage(languageCode: string) {
        this.setLanguageCode = languageCode;
        this.router.navigate([
            `/${languageCode}/${this.router.url.split('/').slice(2).join('/')}`,
        ]);
    }

    ngOnDestroy() {
        this.cookieService.unsubscribe();
    }
}
